import { render, staticRenderFns } from "./ArticlesGlobal.vue?vue&type=template&id=5eb62d8c&"
import script from "./ArticlesGlobal.vue?vue&type=script&lang=js&"
export * from "./ArticlesGlobal.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesGlobal.vue?vue&type=style&index=0&id=5eb62d8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports